<template>
	<div class="form-settings">
		<form>
			<div class="form-group">
				<label for="your-name" class="form-label">Name</label>
				<input type="text" class="form-control" id="your-name" placeholder="" />
			</div>
		</form>
		<h4>Themes</h4>
		<ThemePicker></ThemePicker>
		<p>More themes will be unlocked as you use UnderlineMe.</p>
	</div>
</template>

<script>
import ThemePicker from '@/components/ui/theme-picker';
export default {
	components: {
		ThemePicker,
	},
};
</script>

<style lang="scss">
.form-settings {
	width: 100%;
}
</style>